import { useTranslation } from "react-i18next";
import CustomSelect from "../Forms/Element/CustomSelect";

const GenderSelect = (props) => {

    const { t } = useTranslation();
    const options = [
        { value: "M", label: t('masculine') },
        { value: "F", label: t('feminine') }
    ];

    return (
        <CustomSelect
            placeholder={t('gender_placeholder')}
            options={options}
            {...props}
        />
    );
}

export default GenderSelect;